export type CompanyProficiencyPresetId =
  | 'standard'
  | 'apple'
  | 'google'
  | 'meta'

export type CompanyProficiencyPreset = {
  id: CompanyProficiencyPresetId
  name: string
  minProficiencyThreshold: number
  maxProficiencyThreshold: number
}

export const COMPANY_PROFICIENCY_PRESETS: CompanyProficiencyPreset[] = [
  {
    id: 'standard',
    name: 'Standard',
    minProficiencyThreshold: 60,
    maxProficiencyThreshold: 70,
  },
  {
    id: 'apple',
    name: 'Apple',
    minProficiencyThreshold: 60,
    maxProficiencyThreshold: 70,
  },
  {
    id: 'google',
    name: 'Google',
    minProficiencyThreshold: 60,
    maxProficiencyThreshold: 70,
  },
  {
    id: 'meta',
    name: 'Meta',
    minProficiencyThreshold: 60,
    maxProficiencyThreshold: 70,
  },
]

export function getPresetProficiencyRange(id: CompanyProficiencyPresetId): {
  minProficiencyThreshold: number
  maxProficiencyThreshold: number
} {
  const preset = COMPANY_PROFICIENCY_PRESETS.find((p) => p.id === id)
  if (!preset) throw new Error(`Unknown proficiency preset: ${id}`)
  return {
    minProficiencyThreshold: preset.minProficiencyThreshold,
    maxProficiencyThreshold: preset.maxProficiencyThreshold,
  }
}
